import { memo } from 'react';

import { TableListProps } from './TableList.types';
import { cn } from '../../lib/styles';

const TableListBase = ({ children, className, ...rest }: TableListProps) => {
  return (
    <div className={cn('flex flex-col', className)} {...rest}>
      {children}
    </div>
  );
};

export const TableList = memo(TableListBase);
